import React from 'react';
import PropTypes from 'prop-types';
import Table, { Row, Column } from 'components/molecules/TableList';
const PriceTable = ({ prices = null }) => (
  <Table zebra>
    {prices &&
      prices.map(price => (
        <Row
          key={`price_table_row_${price.unitTypeName}_${price.priceDetails.priceBasisName}`}
        >
          <Column width="15%" heading>
            {price.unitTypeName}
          </Column>
          <Column width="35%">{price.name}</Column>
          <Column width="25%">{price.priceDetails.priceBasisName}</Column>
          <Column width="25%">{price.priceDetails.price}</Column>
        </Row>
      ))}
  </Table>
);
PriceTable.propTypes = {
  prices: PropTypes.any,
};

export default PriceTable;
